<script lang="ts" setup>
import NothingFound from '@jaaluu/components/NothingFound.vue';
import TextWithTooltips from '@jaaluu/components/TextWithTooltips.vue';
import stores from '@jaaluu/stores';
import { t } from '@shared/i18n';
import sharedStores from '@shared/shared-stores';
import { onMounted, Ref, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const { favWordmapsLang } = stores.favorites.state;
const { langForeign, langNative } = stores.language.state;
const { nothingFound } = stores.assets.state;
const { toggleFavoriteWordmap } = stores.favorites.funcs;
const { getHumanizedDate } = sharedStores.datetime.funcs;

const headers: Ref<{ key: string; title: string; sortable?: boolean }[]> = ref([]);
const sortByWords = ref([{ key: 'added_at', order: 'desc' }]);

onMounted(() => {
  setHeaders();
});

const setHeaders = () => {
  headers.value = [
    {
      key: 'actions',
      title: '',
      width: 50,
      sortable: false
    },
    {
      key: 'word',
      title: t('favorites.word')
    }
  ];
};

watch(
  () => langForeign.value,
  () => {
    setHeaders();
  }
);
</script>
<template>
  <div class="pa-2" v-if="langForeign">
    <div class="title d-flex align-center">
      <v-icon icon="mdi-star" size="x-small" class="mr-2" /> {{ t('general.wordmap') }}
    </div>
    <NothingFound v-if="favWordmapsLang.length === 0" :t_key="'favorites.no_favorites_found'" />
    <div v-else>
      <v-data-table-virtual
        :items="favWordmapsLang"
        :headers="headers"
        v-model:sort-by="sortByWords"
        hide-default-footer
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            @click="() => router.push(`/${langForeign}/wordmap/${item.word}`)"
            size="x-small"
            variant="text"
            color="green"
            class="read-view-button"
            >{{ t(`general.open`) }}</v-btn
          >
        </template>
        <template v-slot:item.word="{ item }">
          <div class="d-flex justify-space-between align-center">
            <div>
              <TextWithTooltips :text="item.word" />
              <span class="subtitle-sm">{{
                getHumanizedDate(item.added_at.toString(), langNative!)
              }}</span>
            </div>
            <v-btn
              @click="() => toggleFavoriteWordmap(item.word, item.data, langForeign!)"
              size="x-small"
              variant="text"
              color="grey"
              icon="mdi-close"
            />
          </div>
        </template>
      </v-data-table-virtual>
    </div>
  </div>
</template>

<style scoped lang="scss">
.flag-icon {
  width: 25px;
}

.height-fav-url {
  height: 80px;
}
</style>
